import Sentry from './Sentry';

const tracesSampleRate = import.meta.env.ENV === 'prod' ? 0.05 : 1;

export default new Sentry({
    sentryDSN: import.meta.env.SENTRY_DSN,
    env: import.meta.env.ENV,
    tracesSampleRate,
    autoSessionTracking: true,
    release: `${import.meta.env.AWS_DELIVERY_STREAM_NAME}_${import.meta.env.ENV}_${import.meta.env.RELEASE_DATE}`,
});
